import React from 'react'
type Props = {
  width?: string
  height?: string
  fill?: string
  stroke?: string
}
const SuccessStatusIcon = ({
  fill = '#62AF83',
  stroke = 'white',
  width = '32',
  height = '32',
}: Props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 32 32'
      fill='none'
    >
      <circle
        cx='16'
        cy='16'
        r='16'
        fill={fill}
      />
      <path
        d='M21.3333 12L14 19.3333L10.6666 16'
        stroke={stroke}
        strokeWidth='2.5'
        strokeLinejoin='round'
        strokeLinecap='round'
      />
    </svg>
  )
}

export default SuccessStatusIcon
